module.exports = __webpack_public_path__ + "img/lk-mode-circle-active.a63f6a32.svg";